if (!customElements.get("option-information")) {
  class OptionInformation extends HTMLElement {
    constructor() {
      super();

      this.openButton.addEventListener("click", () => {
        this.showModal();
      })

      this.closeButton.addEventListener("click", () => {
        this.hideModal();
      })
    }

    get openButton() {
      return this._openButton = this._openButton || this.querySelector('button[data-open]');
    }

    get closeButton() {
      return this._closeButton = this._closeButton || this.querySelector('button[data-close]');
    }

    get modal() {
      return this._modal = this._modal || this.querySelector('[data-modal]');
    }

    get modalContent() {
      return this._modalContent = this._modalContent || this.querySelector('[data-modal-content]');
    }

    get siteHeader() {
      return this._siteHeader = this._siteHeader || document.querySelector(".section-header");
    }

    get siteAnnouncementBar() {
      return this._siteAnnouncementBar = this._siteAnnouncementBar || document.querySelector(".section-announcement-bar");
    }

    get siteStickyCart() {
      return this._siteStickyCart = this._siteStickyCart || document.querySelector(".product__sticky-cart");
    }

    showModal() {
      this.hideSiteHeaders();
      this.modal.classList.add("option-information-modal--visible");
      
      setTimeout(() => this.modalContent.classList.add("option-information-modal__content--visible"), 1);
    }

    hideModal() {
      this.modalContent.classList.remove("option-information-modal__content--visible");

      setTimeout(() => {
        this.showSiteHeaders();
        this.modal.classList.remove("option-information-modal--visible")
      }, 300);
      
    }

    hideSiteHeaders() {
      this.siteAnnouncementBar?.setAttribute("style", "z-index:0;");
      this.siteHeader?.setAttribute("style", "z-index:0;");
      this.siteStickyCart?.setAttribute("style", "z-index:0;");
    }

    showSiteHeaders() {
      this.siteAnnouncementBar?.removeAttribute("style", "z-index:0;");
      this.siteHeader?.removeAttribute("style", "z-index:0;");
      this.siteStickyCart?.removeAttribute("style", "z-index:0;");
    }
  }

  customElements.define("option-information", OptionInformation)
}